import ChatState from "state/ChatState";

const chatState = new ChatState();

export default chatState;
